import { Multicall } from "ethereum-multicall";
import { factoryAbi, erc20Abi, presaleAbi } from "./launchPad";

export const multicallCustomContractAddress =
  "0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576";

function isNotZeroAddress(addr) {
  return addr !== "0x0000000000000000000000000000000000000000";
}

export const getBalances = async (
  presaleAddress,
  tokenAddress,
  userAddress,
  // busdAddress,
  web3Instance
) => {
  const multicall = new Multicall({
    multicallCustomContractAddress,
    web3Instance,
    tryAggregate: true,
  });

  if (!presaleAddress || presaleAddress.length === 0) return [];

  // get user busd balance
  // get user busd allowance
  // get user token balance

  // const busdCalls = [{
  //   methodName: "balanceOf",
  //   methodParameters: [userAddress],
  // }, {
  //   methodName: "allowance",
  //   methodParameters: [userAddress, presaleAddress],
  // }];

  const tokenCalls = [
    {
      methodName: "allowance",
      methodParameters: [userAddress, presaleAddress],
    },
  ];

  const presaleCalls = [
    {
      methodName: "isWhitelisted",
      methodParameters: [userAddress],
    },
    {
      methodName: "raisedFunds",
      methodParameters: [],
    },
    {
      methodName: "softCap",
      methodParameters: [],
    },
    {
      methodName: "hardCap",
      methodParameters: [],
    },
    {
      methodName: "userBNBAmount",
      methodParameters: [userAddress],
    },
    {
      methodName: "isClaimed",
      methodParameters: [userAddress],
    },
  ];

  const callContext = [
    // {
    //   reference: "BusdCalls",
    //   contractAddress: busdAddress,
    //   abi: erc20Abi,
    //   calls: busdCalls,
    // },
    {
      reference: "TokenCalls",
      contractAddress: tokenAddress,
      abi: erc20Abi,
      calls: tokenCalls,
    },
    {
      reference: "PresaleCalls",
      contractAddress: presaleAddress,
      abi: presaleAbi,
      calls: presaleCalls,
    },
  ];

  const results = await multicall.call(callContext);

  const balances = {
    // busdBalance: results.results["BusdCalls"].callsReturnContext[0].returnValues[0],
    // tokenXBalance: results.results["TokenCalls"].callsReturnContext[0].returnValues[0],
    // presaleTokenXBalance: results.results["TokenCalls"].callsReturnContext[1].returnValues[0],
    isWhitelisted:
      results.results["PresaleCalls"].callsReturnContext[0].returnValues[0],
    raisedFunds:
      results.results["PresaleCalls"].callsReturnContext[1].returnValues[0],
    softCap:
      results.results["PresaleCalls"].callsReturnContext[2].returnValues[0],
    hardCap:
      results.results["PresaleCalls"].callsReturnContext[3].returnValues[0],
    userBNBAmount:
      results.results["PresaleCalls"].callsReturnContext[4].returnValues[0],
    isClaimed:
      results.results["PresaleCalls"].callsReturnContext[5].returnValues[0],
    allowance:
      results.results["TokenCalls"].callsReturnContext[0].returnValues[0],
  };

  return balances;
};

export const getTokenInfo = async (tokenAddress, web3Instance) => {
  const multicall = new Multicall({
    multicallCustomContractAddress,
    web3Instance,
    tryAggregate: true,
  });

  const tokenCalls = [
    {
      methodName: "name",
      methodParameters: [],
    },
    {
      methodName: "symbol",
      methodParameters: [],
    },
    {
      methodName: "totalSupply",
      methodParameters: [],
    },
    {
      methodName: "decimals",
      methodParameters: [],
    },
  ];

  const callContext = [
    {
      reference: "TokenInfoCalls",
      contractAddress: tokenAddress,
      abi: erc20Abi,
      calls: tokenCalls,
    },
  ];

  const { results } = await multicall.call(callContext);

  // console.log(results);

  return {
    name: results.TokenInfoCalls.callsReturnContext[0].returnValues[0],
    symbol: results.TokenInfoCalls.callsReturnContext[1].returnValues[0],
    totalSupply: results.TokenInfoCalls.callsReturnContext[2].returnValues[0],
    decimals: results.TokenInfoCalls.callsReturnContext[3].returnValues[0],
  };
};

export const getPresaleDetails = async (
  presaleFactoryAddress,
  web3Instance,
  presaleAddressArray
) => {
  const multicall = new Multicall({
    multicallCustomContractAddress,
    web3Instance,
    tryAggregate: true,
  });

  const presaleAddresses = presaleAddressArray.filter(isNotZeroAddress);
  // const tokenAddresses = presaleAddressesAndTokenAddresses[1];

  if (presaleAddresses.length === 0) return [];

  const calls1 = presaleAddresses.map((addr) => ({
    methodName: "getPresaleDetails",
    methodParameters: [addr],
  }));

  // const calls2 = tokenAddresses.map((addr) => ({
  //   methodName: "getTokenName",
  //   methodParameters: [addr],
  // }));

  // const calls3 = tokenAddresses.map((addr) => ({
  //   methodName: "getTokenSymbol",
  //   methodParameters: [addr],
  // }));

  const calls4 = presaleAddresses.map((addr) => ({
    methodName: "getPresaleMediaLinks",
    methodParameters: [addr],
  }));

  const factoryCallContext = [
    {
      reference: "PresaleFactoryCall1",
      contractAddress: presaleFactoryAddress,
      abi: factoryAbi,
      calls: calls1,
    },
    // {
    //   reference: "PresaleFactoryCall2",
    //   contractAddress: presaleFactoryAddress,
    //   abi: factoryAbi,
    //   calls: calls2,
    // },
    // {
    //   reference: "PresaleFactoryCall3",
    //   contractAddress: presaleFactoryAddress,
    //   abi: factoryAbi,
    //   calls: calls3,
    // },
    {
      reference: "PresaleFactoryCall4",
      contractAddress: presaleFactoryAddress,
      abi: factoryAbi,
      calls: calls4,
    },
  ];

  const contractCallContext = factoryCallContext.concat(
    presaleAddresses.map((addr, i) => {
      return {
        reference: "PresaleCall" + (i + 1),
        contractAddress: addr,
        abi: presaleAbi,
        calls: [
          {
            methodName: "getDescription",
            methodParameters: [],
          },
          {
            methodName: "owner",
            methodParameters: [],
          },
          {
            methodName: "isFundsWithdrawn",
            methodParameters: [],
          },
        ],
      };
    })
  );

  const results = await multicall.call(contractCallContext); // can log it in json file to see output structure

  // console.log(results);

  const presales = results.results[
    "PresaleFactoryCall1"
  ].callsReturnContext.map((obj, i) => {
    const [
      [tokenX],

      [
        raisedFunds,
        rate,
        amountTokenToHold,
        tier,
        presaleOpenAt,
        presaleCloseAt,
        bnbMin,
        bnbMax,
        softCap,
        hardCap,
        tokenTotalSupply,
        tokenDecimals,
        participants,
      ],

      [
        presaleIsApproved,
        onlyWhitelistedAllowed,
        isDistributionMode,
        isCanceled,
        isDelayed,
        isRefundAllowed,
      ],

      [tokenName, tokenSymbol],
    ] = obj.returnValues;

    return {
      presaleAddress: presaleAddresses[i],
      tokenName,
      tokenSymbol,
      tokenTotalSupply,
      tokenX,
      raisedFunds,
      rate,
      amountTokenToHold,
      presaleOpenAt,
      presaleCloseAt,
      tier,
      presaleIsApproved,
      presaleMediaLinks:
        results.results["PresaleFactoryCall4"].callsReturnContext[i]
          .returnValues[0],
      description:
        results.results["PresaleCall" + (i + 1)].callsReturnContext[0]
          .returnValues[0],
      owner:
        results.results["PresaleCall" + (i + 1)].callsReturnContext[1]
          .returnValues[0],
      onlyWhitelistedAllowed,
      bnbMin,
      bnbMax,
      softCap,
      hardCap,
      tokenDecimals,
      participants,
      isDistributionMode,
      isCanceled,
      isDelayed,
      isRefundAllowed,
      isFundsWithdrawn:
        results.results["PresaleCall" + (i + 1)].callsReturnContext[2]
          .returnValues[0],
    };
  });

  return presales;
};

// export const getPresalesApprovedAddresses = async (
//   index = 0,
//   amountToFetch = 100,
// ) =>
//   await getContractPresaleFactory()
//     .methods.getPresales(index, amountToFetch)
//     .call();

// export const getPresales = async (index = 0, amountToFetch = 100) =>
//   await getPresaleDetails(
//     await getPresalesApprovedAddresses(index, amountToFetch),
//   );
